import { HeroManifest } from '../../types';

export const manifest: HeroManifest = {
  code: 'ecommerce',
  label: 'Template Ecommerce Collapse',
  fields: [],
};
